import { TagRainbow } from "@smerth/gatsby-theme-theme-ui";
import tagCloudData from "../../../../documentation/data/tagCloud.yaml";
import * as React from 'react';
export default {
  TagRainbow,
  tagCloudData,
  React
};